var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditJarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 44,
    viewBox: "0 0 202 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6634 10.2035V6.08309C20.7033 6.09753 18.4221 7.97801 17.2477 10.2356H23.1082C23.1948 10.2356 23.2812 10.2368 23.3672 10.2391C23.4634 10.2235 23.5621 10.2115 23.6634 10.2035Z",
    fill: "url(#paint0_linear_301_1579)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5367 12.1688C16.4209 12.6864 16.3638 13.2036 16.3695 13.7053H20.3617C20.3365 13.4987 20.375 13.202 20.4788 12.8698C20.5899 12.5141 20.7769 12.1139 21.0458 11.7335C21.5351 11.0414 22.2969 10.413 23.3672 10.2391C23.2812 10.2368 23.1948 10.2356 23.1082 10.2356H17.2477C16.9231 10.8595 16.6831 11.5141 16.5367 12.1688Z",
    fill: "url(#paint1_linear_301_1579)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3003 18.2159C21.3217 18.2162 21.3431 18.2164 21.3647 18.2165C21.3666 18.2165 21.3684 18.2165 21.3703 18.2166C21.3924 18.217 21.4144 18.2177 21.4364 18.2185L20.436 13.7339C20.4344 13.7246 20.4329 13.7151 20.4316 13.7053H20.3617C20.3634 13.7193 20.3654 13.7328 20.3677 13.746L20.3678 13.7468L20.368 13.7475L21.3647 18.2165C21.3445 18.2161 21.3242 18.2159 21.3039 18.2159H21.3003Z",
    fill: "url(#paint2_linear_301_1579)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6634 6.08309V10.2035C23.5621 10.2115 23.4634 10.2235 23.3672 10.2391C23.4897 10.2424 23.6115 10.248 23.7327 10.2559V6.08605C23.7096 6.085 23.6865 6.08401 23.6634 6.08309Z",
    fill: "url(#paint3_linear_301_1579)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6012 42.7814V38.6177C8.38898 38.6177 4.16364 34.3924 4.16364 29.1801V19.6732C4.16364 14.7297 7.96443 10.674 12.8032 10.2689C12.8148 10.2683 12.8263 10.2678 12.8379 10.2671C15.2686 10.0169 17.048 8.20034 17.587 6.07197H17.0096H13.8441H13.6012C13.4619 6.07197 13.3231 6.07406 13.1848 6.07822C13.1215 6.08012 13.0583 6.08246 12.9953 6.08523C5.7647 6.40223 4.56865e-08 12.3645 0 19.6732V29.1801L0.00027107 29.2681C0.047588 36.7394 6.11881 42.7814 13.6012 42.7814Z",
    fill: "url(#paint4_linear_301_1579)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7005 10.2702L23.7327 10.2679V10.2559C23.6115 10.248 23.4897 10.2424 23.3672 10.2391C22.2969 10.413 21.5351 11.0414 21.0458 11.7335C20.7769 12.1139 20.5899 12.5141 20.4788 12.8698C20.375 13.202 20.3365 13.4987 20.3617 13.7053H20.4316C20.4252 13.6569 20.4226 13.6024 20.424 13.5426C20.428 13.3646 20.4672 13.1398 20.545 12.8905C20.654 12.5415 20.8379 12.1479 21.1024 11.7737C21.6314 11.0253 22.4815 10.3561 23.7005 10.2702Z",
    fill: "url(#paint5_linear_301_1579)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1082 38.6177V42.7814L23.1961 42.7811C30.6381 42.734 36.662 36.7101 36.7091 29.2681L36.7094 29.1801V19.6732C36.7094 12.3708 30.9546 6.41246 23.7327 6.08605V10.2559C28.6538 10.5775 32.5457 14.6708 32.5457 19.6732V29.1801C32.5457 34.3924 28.3204 38.6177 23.1082 38.6177Z",
    fill: "url(#paint6_linear_301_1579)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 30.6374V35.148C25.5964 35.148 29.0761 31.6683 29.0761 27.3759V21.4774C29.0761 17.185 25.5964 13.7053 21.3039 13.7053H20.5753H20.4316C20.4329 13.7151 20.4344 13.7246 20.436 13.7339L21.4364 18.2185C23.1763 18.2881 24.5654 19.7205 24.5654 21.4774V27.3759C24.5654 29.1772 23.1052 30.6374 21.3039 30.6374Z",
    fill: "url(#paint7_linear_301_1579)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4054 35.148V30.6374C13.6042 30.6374 12.1439 29.1772 12.1439 27.3759V21.4774C12.1439 19.6761 13.6042 18.2159 15.4054 18.2159H16.9321C15.4054 17.3485 14.6053 15.5789 14.6053 13.746C10.6888 14.1465 7.63333 17.4552 7.63333 21.4774V27.3759C7.63333 31.6348 11.0589 35.0936 15.305 35.1474L15.4054 35.148Z",
    fill: "url(#paint8_linear_301_1579)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 35.148V30.6374H15.4054V35.148H21.3039Z",
    fill: "url(#paint9_linear_301_1579)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1082 42.7814V38.6177H13.6012V42.7814H23.1082Z",
    fill: "url(#paint10_linear_301_1579)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3647 18.2165C21.3431 18.2164 21.3217 18.2162 21.3003 18.2159C19.2446 18.1906 17.8939 17.439 17.1348 16.328C16.6256 15.5828 16.3806 14.6728 16.3695 13.7053H20.3617C20.3634 13.7193 20.3654 13.7328 20.3677 13.746L20.3678 13.7468L20.368 13.7475L21.3647 18.2165Z",
    fill: "url(#paint11_linear_301_1579)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6012 6.07197H13.8441H17.0096H17.587C18.1268 3.94086 17.4231 1.49712 14.885 0L13.0227 3.435C13.6517 3.71405 14.4228 4.95509 13.2383 6.03098C13.2209 6.04676 13.2031 6.06251 13.1848 6.07822C13.3231 6.07406 13.4619 6.07197 13.6012 6.07197Z",
    fill: "url(#paint12_linear_301_1579)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1848 6.07822C13.2031 6.06251 13.2209 6.04676 13.2383 6.03098C13.1964 6.06622 13.0993 6.08007 12.9953 6.08523C13.0583 6.08246 13.1215 6.08012 13.1848 6.07822Z",
    fill: "url(#paint13_linear_301_1579)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4316 13.7053H20.5753C20.4712 13.7053 20.4253 13.6359 20.424 13.5426C20.4226 13.6024 20.4252 13.6569 20.4316 13.7053Z",
    fill: "url(#paint14_linear_301_1579)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6634 10.2035V6.08309C20.7033 6.09753 18.4221 7.97801 17.2477 10.2356H23.1082C23.1948 10.2356 23.2812 10.2368 23.3672 10.2391C23.4634 10.2235 23.5621 10.2115 23.6634 10.2035Z",
    fill: "url(#paint15_linear_301_1579)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5367 12.1688C16.4209 12.6864 16.3638 13.2036 16.3695 13.7053H20.3617C20.3365 13.4987 20.375 13.202 20.4788 12.8698C20.5899 12.5141 20.7769 12.1139 21.0458 11.7335C21.5351 11.0414 22.2969 10.413 23.3672 10.2391C23.2812 10.2368 23.1948 10.2356 23.1082 10.2356H17.2477C16.9231 10.8595 16.6831 11.5141 16.5367 12.1688Z",
    fill: "url(#paint16_linear_301_1579)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3003 18.2159C21.3217 18.2162 21.3431 18.2164 21.3647 18.2165C21.3666 18.2165 21.3684 18.2165 21.3703 18.2166C21.3924 18.217 21.4144 18.2177 21.4364 18.2185L20.436 13.7339C20.4344 13.7246 20.4329 13.7151 20.4316 13.7053H20.3617C20.3634 13.7193 20.3654 13.7328 20.3677 13.746L20.3678 13.7468L20.368 13.7475L21.3647 18.2165C21.3445 18.2161 21.3242 18.2159 21.3039 18.2159H21.3003Z",
    fill: "url(#paint17_linear_301_1579)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6634 6.08309V10.2035C23.5621 10.2115 23.4634 10.2235 23.3672 10.2391C23.4897 10.2424 23.6115 10.248 23.7327 10.2559V6.08605C23.7096 6.085 23.6865 6.08401 23.6634 6.08309Z",
    fill: "url(#paint18_linear_301_1579)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7005 10.2702L23.7327 10.2679V10.2559C23.6115 10.248 23.4897 10.2424 23.3672 10.2391C22.2969 10.413 21.5351 11.0414 21.0458 11.7335C20.7769 12.1139 20.5899 12.5141 20.4788 12.8698C20.375 13.202 20.3365 13.4987 20.3617 13.7053H20.4316C20.4252 13.6569 20.4226 13.6024 20.424 13.5426C20.428 13.3646 20.4672 13.1398 20.545 12.8905C20.654 12.5415 20.8379 12.1479 21.1024 11.7737C21.6314 11.0253 22.4815 10.3561 23.7005 10.2702Z",
    fill: "url(#paint19_linear_301_1579)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 30.6374V35.148C25.5964 35.148 29.0761 31.6683 29.0761 27.3759V21.4774C29.0761 17.185 25.5964 13.7053 21.3039 13.7053H20.5753H20.4316C20.4329 13.7151 20.4344 13.7246 20.436 13.7339L21.4364 18.2185C23.1763 18.2881 24.5654 19.7205 24.5654 21.4774V27.3759C24.5654 29.1772 23.1052 30.6374 21.3039 30.6374Z",
    fill: "url(#paint20_linear_301_1579)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4054 35.148V30.6374C13.6042 30.6374 12.1439 29.1772 12.1439 27.3759V21.4774C12.1439 19.6761 13.6042 18.2159 15.4054 18.2159H16.9321C15.4054 17.3485 14.6053 15.5789 14.6053 13.746C10.6888 14.1465 7.63333 17.4552 7.63333 21.4774V27.3759C7.63333 31.6348 11.0589 35.0936 15.305 35.1474L15.4054 35.148Z",
    fill: "url(#paint21_linear_301_1579)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 35.148V30.6374H15.4054V35.148H21.3039Z",
    fill: "url(#paint22_linear_301_1579)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3647 18.2165C21.3431 18.2164 21.3217 18.2162 21.3003 18.2159C19.2446 18.1906 17.8939 17.439 17.1348 16.328C16.6256 15.5828 16.3806 14.6728 16.3695 13.7053H20.3617C20.3634 13.7193 20.3654 13.7328 20.3677 13.746L20.3678 13.7468L20.368 13.7475L21.3647 18.2165Z",
    fill: "url(#paint23_linear_301_1579)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1848 6.07822C13.2031 6.06251 13.2209 6.04676 13.2383 6.03098C13.1964 6.06622 13.0993 6.08007 12.9953 6.08523C13.0583 6.08246 13.1215 6.08012 13.1848 6.07822Z",
    fill: "url(#paint24_linear_301_1579)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4316 13.7053H20.5753C20.4712 13.7053 20.4253 13.6359 20.424 13.5426C20.4226 13.6024 20.4252 13.6569 20.4316 13.7053Z",
    fill: "url(#paint25_linear_301_1579)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4054 35.148V30.6374C13.6042 30.6374 12.1439 29.1772 12.1439 27.3759V21.4774C12.1439 19.6761 13.6042 18.2159 15.4054 18.2159H16.9321C15.4054 17.3485 14.6053 15.5789 14.6053 13.746C10.6888 14.1465 7.63333 17.4552 7.63333 21.4774V27.3759C7.63333 31.6348 11.0589 35.0936 15.305 35.1474L15.4054 35.148Z",
    fill: "#F1D506"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1848 6.07822C13.2031 6.06251 13.2209 6.04676 13.2383 6.03098C13.1964 6.06622 13.0993 6.08007 12.9953 6.08523C13.0583 6.08246 13.1215 6.08012 13.1848 6.07822Z",
    fill: "#F1D506"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4316 13.7053H20.5753C20.4712 13.7053 20.4253 13.6359 20.424 13.5426C20.4226 13.6024 20.4252 13.6569 20.4316 13.7053Z",
    fill: "#F1D506"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3003 18.2159C21.3217 18.2162 21.3431 18.2164 21.3647 18.2165C21.3445 18.2161 21.3242 18.2159 21.3039 18.2159H21.3003Z",
    fill: "#F1D506"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3647 18.2165C21.3431 18.2164 21.3217 18.2162 21.3003 18.2159H21.3039C21.3242 18.2159 21.3445 18.2161 21.3647 18.2165Z",
    fill: "#F1D506"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3203 34.9299C53.1105 34.9299 51.1324 34.4131 49.3859 33.3795C47.6514 32.3459 46.2851 30.837 45.2871 28.853C44.2891 26.857 43.7902 24.4215 43.7902 21.5464C43.7902 18.8257 44.2773 16.4674 45.2515 14.4715C46.2257 12.4637 47.586 10.9132 49.3325 9.82021C51.0789 8.71532 53.1046 8.16287 55.4094 8.16287C57.1083 8.16287 58.6706 8.49552 60.0963 9.16084C61.5339 9.82615 62.6922 10.8122 63.5714 12.1191C64.4624 13.4141 64.9377 15.018 64.9971 16.9308H61.5933C61.522 15.6595 61.1893 14.6081 60.5953 13.7765C60.0131 12.9329 59.2587 12.3033 58.332 11.8874C57.4053 11.4597 56.3836 11.2459 55.2668 11.2459C53.7342 11.2459 52.3561 11.6558 51.1324 12.4755C49.9206 13.2834 48.9642 14.4537 48.2632 15.9863C47.5623 17.5189 47.2118 19.3663 47.2118 21.5286C47.2118 23.9879 47.5801 25.9779 48.3167 27.4986C49.0533 29.0074 50.0394 30.1123 51.2749 30.8133C52.5105 31.5023 53.8768 31.8469 55.3738 31.8469C56.74 31.8469 57.8687 31.6033 58.7597 31.1162C59.6627 30.6172 60.3517 29.9638 60.827 29.1559C61.3022 28.348 61.5695 27.4748 61.6289 26.5362H64.9971C64.8901 28.2589 64.4327 29.75 63.6249 31.0093C62.8289 32.2686 61.7299 33.2369 60.328 33.9141C58.9261 34.5913 57.2568 34.9299 55.3203 34.9299ZM69.1067 34.5557V15.113H71.9224L72.2789 22.58L71.8868 21.5642C71.97 20.8276 72.1304 20.0613 72.368 19.2653C72.6175 18.4693 72.9679 17.7268 73.4194 17.0377C73.8827 16.3367 74.4708 15.7724 75.1837 15.3447C75.9084 14.917 76.7935 14.7031 77.839 14.7031C78.041 14.7031 78.2311 14.715 78.4093 14.7388C78.5994 14.7626 78.7835 14.7923 78.9617 14.8279V18.3386C78.6647 18.2436 78.3499 18.1842 78.0172 18.1604C77.6964 18.1248 77.3935 18.1069 77.1083 18.1069C76.5262 18.1069 75.9381 18.2198 75.3441 18.4455C74.75 18.6713 74.1976 19.0336 73.6867 19.5326C73.1758 20.0197 72.7541 20.6553 72.4214 21.4395V34.5557H69.1067ZM89.9029 34.823C88.1327 34.823 86.5764 34.4369 85.2338 33.6646C83.9032 32.8924 82.8696 31.7578 82.133 30.2608C81.3964 28.752 81.0281 26.9105 81.0281 24.7363C81.0281 22.6453 81.4083 20.8514 82.1686 19.3544C82.929 17.8575 83.9745 16.711 85.3051 15.915C86.6358 15.119 88.1505 14.721 89.8495 14.721C91.5365 14.721 92.98 15.0833 94.18 15.808C95.3918 16.5328 96.3244 17.5723 96.9778 18.9267C97.6313 20.2692 97.952 21.879 97.9402 23.7562C97.9402 24.1364 97.9283 24.4512 97.9045 24.7007C97.8808 24.9502 97.8629 25.2116 97.8511 25.4848H84.3428C84.426 27.6233 84.9606 29.245 85.9467 30.3499C86.9447 31.4429 88.2159 31.9895 89.7604 31.9895C91.0672 31.9895 92.0771 31.7162 92.7899 31.1697C93.5146 30.6113 93.972 29.8985 94.1621 29.0312H97.4055C97.3224 30.2668 96.9422 31.3182 96.265 32.1855C95.5997 33.0528 94.7205 33.7121 93.6275 34.1636C92.5345 34.6032 91.293 34.823 89.9029 34.823ZM86.1071 22.9899H94.6077C94.5839 21.3266 94.174 20.0197 93.378 19.0693C92.582 18.1188 91.3642 17.6436 89.7247 17.6436C88.002 17.6436 86.6952 18.2317 85.8041 19.4079C84.9131 20.5722 84.426 22.182 84.3428 24.2373C84.4378 23.7502 84.6279 23.4235 84.9131 23.2572C85.2101 23.079 85.6081 22.9899 86.1071 22.9899ZM108.709 34.7695C107.129 34.7695 105.763 34.3537 104.61 33.5221C103.47 32.6904 102.591 31.5202 101.973 30.0113C101.367 28.5025 101.064 26.7382 101.064 24.7185C101.064 22.485 101.438 20.6316 102.187 19.1584C102.947 17.6733 103.921 16.5684 105.109 15.8437C106.309 15.1071 107.574 14.7388 108.905 14.7388C110.2 14.7388 111.216 14.9586 111.952 15.3982C112.701 15.8377 113.247 16.3486 113.592 16.9308C113.948 17.501 114.162 17.9941 114.234 18.4099L115.285 18.5881L114.002 19.7108C113.919 19.4613 113.717 19.1762 113.396 18.8554C113.075 18.5228 112.618 18.2376 112.024 18C111.43 17.7505 110.675 17.6258 109.76 17.6258C108.228 17.6258 106.963 18.202 105.965 19.3544C104.967 20.495 104.468 22.3067 104.468 24.7898C104.468 27.0946 104.937 28.8648 105.875 30.1004C106.826 31.336 108.044 31.9538 109.529 31.9538C110.455 31.9538 111.222 31.7934 111.828 31.4726C112.445 31.1519 112.927 30.7598 113.271 30.2965C113.628 29.8331 113.871 29.3995 114.002 28.9955L114.18 29.6371L114.002 30.2965C113.942 30.6885 113.812 31.14 113.61 31.6509C113.408 32.1498 113.105 32.6369 112.701 33.1122C112.297 33.5874 111.768 33.9854 111.115 34.3062C110.473 34.6151 109.671 34.7695 108.709 34.7695ZM114.02 34.5557L114.002 6.8263H117.299L117.317 34.5557H114.02ZM123.36 34.5557V15.22H126.71L126.657 34.5557H123.36ZM125.053 12.1013C124.399 12.1013 123.841 11.8756 123.378 11.4241C122.926 10.9726 122.7 10.3905 122.7 9.67765C122.7 8.97669 122.926 8.40048 123.378 7.94902C123.841 7.49755 124.399 7.27182 125.053 7.27182C125.694 7.27182 126.241 7.49755 126.692 7.94902C127.156 8.40048 127.387 8.97669 127.387 9.67765C127.387 10.3905 127.156 10.9726 126.692 11.4241C126.229 11.8756 125.682 12.1013 125.053 12.1013ZM138.071 34.823C136.562 34.823 135.409 34.4369 134.613 33.6646C133.829 32.8805 133.437 31.7697 133.437 30.3321V19.7821C133.437 19.4019 133.514 19.0515 133.669 18.7307C133.823 18.398 134.049 18.1842 134.346 18.0891L133.437 15.8793V15.2734L134.239 9.46379H136.716V29.7797C136.716 30.54 136.894 31.0568 137.251 31.3301C137.607 31.5914 138.219 31.7221 139.086 31.7221C139.716 31.7221 140.251 31.7221 140.69 31.7221C141.13 31.7103 141.587 31.6865 142.063 31.6509V34.5735C141.409 34.6923 140.732 34.7636 140.031 34.7873C139.342 34.8111 138.688 34.823 138.071 34.823ZM130.604 18.0891V15.113H141.902V18.0891H130.604ZM157.866 35.0903C156.452 35.0903 155.169 34.8408 154.016 34.3418C152.864 33.8309 151.943 33.0231 151.254 31.9182C150.565 30.8014 150.197 29.3341 150.149 27.5164H153.357C153.369 28.9302 153.755 30.0351 154.515 30.8311C155.287 31.6152 156.41 32.0073 157.883 32.0073C158.786 32.0073 159.541 31.8528 160.147 31.5439C160.764 31.235 161.228 30.6945 161.537 29.9222C161.857 29.15 162.018 28.0748 162.018 26.6966V8.64403H165.439V26.3402C165.439 28.4074 165.142 30.0826 164.548 31.3657C163.954 32.6488 163.093 33.5933 161.964 34.1992C160.836 34.7933 159.469 35.0903 157.866 35.0903ZM175.483 34.7695C174.247 34.7695 173.178 34.5378 172.275 34.0745C171.384 33.5993 170.695 32.9577 170.208 32.1498C169.733 31.342 169.495 30.4271 169.495 29.4054C169.495 28.348 169.703 27.457 170.119 26.7323C170.535 25.9957 171.135 25.3957 171.919 24.9324C172.703 24.4571 173.653 24.1007 174.77 23.8631C175.507 23.6968 176.285 23.5661 177.105 23.471C177.936 23.376 178.732 23.2988 179.493 23.2394C180.253 23.18 180.9 23.1384 181.435 23.1146V22.0276C181.435 20.4712 181.108 19.3544 180.455 18.6772C179.802 17.9881 178.786 17.6436 177.408 17.6436C176.552 17.6436 175.798 17.7565 175.144 17.9822C174.503 18.2079 174.004 18.6297 173.647 19.2475C173.291 19.8534 173.119 20.7444 173.131 21.9206H170.03C169.887 20.3167 170.113 18.9861 170.707 17.9287C171.301 16.8595 172.192 16.0635 173.38 15.5407C174.568 15.0061 175.976 14.7388 177.604 14.7388C178.53 14.7388 179.415 14.8517 180.259 15.0774C181.102 15.2912 181.851 15.6595 182.504 16.1823C183.158 16.6932 183.675 17.3941 184.055 18.2852C184.435 19.1762 184.625 20.293 184.625 21.6355V34.5557H181.399L181.435 30.3321C181.138 31.6746 180.467 32.7498 179.421 33.5577C178.388 34.3656 177.075 34.7695 175.483 34.7695ZM176.249 32.1498C177.117 32.1498 177.913 31.9895 178.637 31.6687C179.374 31.3479 179.992 30.938 180.491 30.439C180.99 29.94 181.304 29.4292 181.435 28.9064V25.1284C180.746 25.1759 179.98 25.2591 179.136 25.3779C178.293 25.4848 177.55 25.6155 176.909 25.7699C175.625 26.067 174.669 26.465 174.039 26.9639C173.422 27.4629 173.113 28.1817 173.113 29.1203C173.113 29.6787 173.232 30.1895 173.469 30.6529C173.719 31.1043 174.075 31.4667 174.538 31.74C175.002 32.0013 175.572 32.138 176.249 32.1498ZM190.233 34.5557V15.113H193.049L193.405 22.58L193.013 21.5642C193.097 20.8276 193.257 20.0613 193.495 19.2653C193.744 18.4693 194.095 17.7268 194.546 17.0377C195.009 16.3367 195.597 15.7724 196.31 15.3447C197.035 14.917 197.92 14.7031 198.966 14.7031C199.168 14.7031 199.358 14.715 199.536 14.7388C199.726 14.7626 199.91 14.7923 200.088 14.8279V18.3386C199.791 18.2436 199.476 18.1842 199.144 18.1604C198.823 18.1248 198.52 18.1069 198.235 18.1069C197.653 18.1069 197.065 18.2198 196.471 18.4455C195.877 18.6713 195.324 19.0336 194.813 19.5326C194.302 20.0197 193.881 20.6553 193.548 21.4395V34.5557H190.233Z",
    fill: "#0C113E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_301_1579",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_301_1579",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_301_1579",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_301_1579",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_301_1579",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_301_1579",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_301_1579",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_301_1579",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_301_1579",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_301_1579",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_301_1579",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_301_1579",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditJarLogo);
export default __webpack_public_path__ + "static/media/creditJarLogo.1d138da5c7be6cf3b2077bec66fbaa3a.svg";
export { ForwardRef as ReactComponent };